import * as React from 'react';
import CommonHeader from '@vcd-ecm-ui/Header';
import Logo from './components/Logo';
import ECMHeaderUtilities from './components/ECMHeaderUtilities';

const Header = (): JSX.Element => {
  const version: string = process && process.env && process.env.NODE_ENV === 'development' ? `v${process.env.VERSION}` : null;

  return (
    <CommonHeader headerText="EXEMPTION CERTIFICATE MANAGER" version={version} Logo={Logo} HeaderUtilities={ECMHeaderUtilities} />
  );
};

export default Header;
